"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleGroupCondition = void 0;
const market_rule_condition_1 = require("./market-rule-condition");
class MarketRuleGroupCondition extends market_rule_condition_1.MarketRuleCondition {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.conditions = obj.conditions;
        }
    }
}
exports.MarketRuleGroupCondition = MarketRuleGroupCondition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtZ3JvdXAtY29uZGl0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbnRlbnQvaGlzdG9yaWNhbC1wcmljaW5nL3RpbWUtc2VyaWVzL3NlcnZpY2VzL3J1bGUtZW5naW5lLXNlcnZpY2UvY2xhc3Nlcy9tYXJrZXQtcnVsZS1ncm91cC1jb25kaXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUVBQThEO0FBRTlELE1BQWEsd0JBQXlCLFNBQVEsMkNBQW1CO0lBRzdEOzs7T0FHRztJQUNILFlBQW1CLEdBQXVDO1FBQ3RELEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUVYLElBQUksR0FBRyxFQUFFLENBQUM7WUFDTixJQUFJLENBQUMsVUFBVSxHQUFHLEdBQUcsQ0FBQyxVQUFXLENBQUM7UUFDdEMsQ0FBQztJQUNMLENBQUM7Q0FDSjtBQWRELDREQWNDIn0=